document.addEventListener("DOMContentLoaded", function () {
  const announcements = document.querySelectorAll(".announcement-bar");
  let currentIndex = 0;
  const intervalTime = 3000;

  function showAnnouncement(index) {
    announcements.forEach((bar, i) => {
      if (i === index) {
        bar.classList.add("active");
      } else {
        bar.classList.remove("active");
      }
    });
  }

  function rotateAnnouncements() {
    currentIndex = (currentIndex + 1) % announcements.length;
    showAnnouncement(currentIndex);
  }

  // Show first announcement initially
  showAnnouncement(currentIndex);

  // Start rotating
  setInterval(rotateAnnouncements, intervalTime);
});
